// src/utils/format-error.ts
var formatError = (error) => {
  if ("graphQLErrors" in error && error.graphQLErrors.length > 0) {
    return error.graphQLErrors.length === 1 ? [error.graphQLErrors[0].message] : Array.from(error.graphQLErrors).map((error2) => error2.message);
  }
  if ("networkError" in error) {
    console.error(error.networkError);
    return [
      "Sorry we had a problem connecting. Please refresh your browser and try again."
    ];
  }
  return [error.message];
};

export {
  formatError
};
